"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Header_1 = require("./Header");
exports.default = Header_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Console/components/Header/index.js
// module id = 546
// module chunks = 8